import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart';
import type { ILandingTelegramAuthTimePoint } from '@/entities/landing.entity';
import { LineChartIcon } from 'lucide-react';
import { Area, AreaChart, CartesianGrid, XAxis, YAxis } from 'recharts';

interface LandingTelegramAuthTimeseriesChartProps {
	data: ILandingTelegramAuthTimePoint[];
}

const chartConfig = {
	starts: { label: 'Старт', color: 'var(--chart-4)' },
	sessions: { label: 'Сессия', color: 'var(--chart-2)' },
	codeSuccess: { label: 'Код OK', color: 'var(--chart-5)' },
	codeFailed: { label: 'Код ошибка', color: 'var(--destructive)' },
};

function pointHasData(d: ILandingTelegramAuthTimePoint): boolean {
	return d.starts > 0 || d.sessions > 0 || d.codeSuccess > 0 || d.codeFailed > 0;
}

export default function LandingTelegramAuthTimeseriesChart({ data }: LandingTelegramAuthTimeseriesChartProps) {
	const hasData = data.some(pointHasData);

	return (
		<Card className='gap-0 py-0 shadow-sm overflow-hidden'>
			<CardHeader className='border-b px-4 py-3'>
				<div className='flex items-center gap-2'>
					<div className='rounded-lg bg-chart-4/15 p-1.5'>
						<LineChartIcon className='text-chart-4' size={16} />
					</div>
					<CardTitle className='text-sm'>TG auth по времени</CardTitle>
				</div>
			</CardHeader>
			<CardContent className='px-2 py-3'>
				{!hasData ? (
					<div className='h-[180px] flex items-center justify-center text-sm text-muted-foreground'>Нет данных</div>
				) : (
					<ChartContainer config={chartConfig} className='h-[180px] w-full'>
						<AreaChart data={data} margin={{ top: 8, right: 8, left: -20, bottom: 0 }}>
							<CartesianGrid strokeDasharray='3 3' vertical={false} />
							<XAxis dataKey='label' tickLine={false} axisLine={false} tick={{ fontSize: 10 }} interval='preserveStartEnd' />
							<YAxis tickLine={false} axisLine={false} tick={{ fontSize: 10 }} allowDecimals={false} />
							<ChartTooltip content={<ChartTooltipContent />} />
							<Area type='monotone' dataKey='starts' stroke='var(--chart-4)' fill='var(--chart-4)' fillOpacity={0.25} strokeWidth={1.5} />
							<Area type='monotone' dataKey='sessions' stroke='var(--chart-2)' fill='var(--chart-2)' fillOpacity={0.25} strokeWidth={1.5} />
							<Area type='monotone' dataKey='codeSuccess' stroke='var(--chart-5)' fill='var(--chart-5)' fillOpacity={0.2} strokeWidth={1.5} />
							<Area type='monotone' dataKey='codeFailed' stroke='var(--destructive)' fill='var(--destructive)' fillOpacity={0.15} strokeWidth={1.5} />
						</AreaChart>
					</ChartContainer>
				)}
			</CardContent>
		</Card>
	);
}
